import { useState } from "react";
import { TUseAxesTitle } from "components/Charts/chart.types";
import useLabeledAxesVisibility from "../hooks/useLabeledAxesVisibility";
import { createLabel, getConfiguration } from "utils";

const useTeamCompetitiveAxes: TUseAxesTitle = (chartAxesTitles, chartDataState, chartRef, chartName) => {
    const [titlesVisible, setTitlesVisible] = useState(true);

    const renderAxesTitles = (chart: Highcharts.Chart) => {
        const { plotLeft, plotTop, plotWidth, plotHeight } = chart;
        const { current: titles } = chartAxesTitles;

        if (titles.length === 0) {
            const {
                xAxis: { title: titleXAxis },
                yAxis: { title: titleYAxis },
            } = chartDataState;

            const optionsYAxis = getConfiguration(titleYAxis?.text ?? "", 0, 0);
            const optionsXAxis = getConfiguration(titleXAxis?.text ?? "", 0, 0);

            titles.push({
                key: "yAxisTitle",
                svg: createLabel(chart.renderer, optionsYAxis),
            });
            titles.push({
                key: "xAxisTitle",
                svg: createLabel(chart.renderer, optionsXAxis),
            });
        }

        titles.forEach((element) => {
            const labelBBox = element.svg.getBBox();

            if (element.key === "yAxisTitle") {
                element.svg.attr({
                    x: plotWidth / 2 + plotLeft - labelBBox.width / 2,
                    y: plotHeight + plotTop,
                });
            } else {
                element.svg.attr({
                    x: 0,
                    y: plotHeight / 2 + plotTop - labelBBox.height / 2,
                });
            }
        });
    };

    useLabeledAxesVisibility(chartRef, chartDataState, titlesVisible, chartAxesTitles, "singleLabelled");

    return { renderAxesTitles, setTitlesVisible };
};

export default useTeamCompetitiveAxes;
